export enum MailingType {
    message = 1,
    bot
}